<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>
              <i class="fa fa-align-justify"></i> Gestion des catégories de document
            </strong>
          </div>
          <b-card-body>
            <v-client-table :columns="columns" :data="allCategories" :options="options" ref="categories_table">
              <div slot="afterFilterWrapper" v-if="canManageCategorie">
                <b-button type="button" @click="editCategory()" size="md" variant="success" class="float-right">
                  <i class="fa fa-plus"></i> Créer une catégorie
                </b-button>
              </div>
              
              <div v-if="props.row.created_at" slot="created_at" slot-scope="props" class="slot-date">
                <span class="badge badge-success p-2">{{ formatDate(props.row.created_at) }}</span>
              </div>
              <div v-if="canManageCategorie" slot="action" slot-scope="props" class="w-auto">
                <i v-b-tooltip.hover title="Modifier la catégorie" class="mr-2 fa fa-edit fa-1_5x text-primary clickable" @click="editCategory(props.row)"></i>
                <i v-b-tooltip.hover title="Supprimer la catégorie" class="fa fa-trash fa-1_5x text-danger clickable" @click="deleteCategory(props.row.id)"></i>
              </div>
            </v-client-table>
            <b-row>
              <b-col sm="12" v-if="canManageCategorie">
                <b-button type="button" @click="editCategory()" size="md" variant="success" class="float-right">
                  <i class="fa fa-plus"></i> Créer une catégorie
                </b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <modal-categorie :selectedCategory="selectedCategory"></modal-categorie>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth';
import {espaceBibliothequeRules as rules, hasRule} from '@/utils/rulesHelper';
import {isEmpty} from '@/utils/fileHelper';
import {formatDate} from '@/utils/communHelper';
import modalCategorie from './ModalCategorie';

export default {
  components: {
    modalCategorie,
  },
  data() {
    return {
      isEmpty,
      formatDate,
      rules,
      hasRule,
      selectedCategory: null,
      allCategories: [],
      columns: [
        'created_at',
        'libelle',
        'libelle_technique',
        'action'
      ],
      options: {
        headings: {
          created_at: 'Date de création',
          libelle: 'Libellé',
          libelle_technique: 'Libellé technique',
          action: ''
        },
        columnsClasses: {
          created_at: "column-xs",
        },
        sortable: ['libelle'],
        filterable: ['libelle'],
        perPage: 10,
        perPageValues: [10, 50, 100],
        texts: {
          filterPlaceholder: 'Libellé'
        },
        orderBy: { column: 'created_at', ascending: false }
      },
      errors: {
        libelle: '',
        libelle_technique: '',
      }
    }
  },
  created() {
    this.getCategories();

    this.$event.on('refresh-categorie-document', () => {
      this.getCategories();
      this.selectedCategory = null;
    });
  },
  methods: {
    getCategories() {
      this.$store.commit("IS_LOADING", true);
      let self = this;
      this.$axios
        .get('/espaceBibliotheque/categories')
        .then(response => {
          this.allCategories = response.data.categories;
          this.$store.commit("IS_LOADING", false);
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
              position: "top",
              type: "warning",
              title: "Attention !!",
              text: 'Une erreur est survenue pendant la récupération des catégories de document. Si le problème persiste contactez le support DOSI.',
              showConfirmButton: false,
              timer: 5000
            });
        });
    },
    editCategory(categorie) {
      this.selectedCategory = !isEmpty(categorie) ? categorie : null;

      this.$bvModal.show('modal-categorie')
    },
    deleteCategory(categoryId) {
      let self = this;
      this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: "Voulez-vous vraiment supprimer cette catégorie ?",
        type: 'warning',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
        }).then((result) => {
          if (!result.value) {
            this.$store.commit('IS_LOADING', true)
            this.$axios
            .delete("/espaceBibliotheque/categorie/delete/"+categoryId)
            .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'La catégorie a bien été supprimée',showConfirmButton: false, timer: 5000})
              this.getCategories()
            })
            .catch(function(error){
              self.$store.commit('IS_LOADING', false);
              let text = 'Une erreur est survenue pendant la suppression de la catégorie, si le problème persiste merci de contacter le support DOSI';
              if (!isEmpty(error) && error.response && error.response.status === 403) {
                text = error.response.data.message;
              }
              self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text: text,showConfirmButton: false, timer: 10000})
            })
          }
        })
    },
    canManageCategorie() {
      return hasRule(rules.CAN_MANAGE_CATEGORIE);
    },
  }
}
</script>

<style>
  .small-action {
    width:  5%;
  }
</style>
